// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__38eYL","textonly":"button_textonly__3n9kl","empty":"button_empty__1dvUF","border":"button_border__1YjeW"};